export function getToken() {
  return getCookie("token");
}

export function setToken(token) {
  setCookie("token", token, 1); // 设置有效期为1天（24小时）
}

export function clearToken() {
  deleteCookie("token");
}

export function dateFormat(dateStr) {
  return moment(dateStr).format("YYYY-MM-DD HH:mm");
}

// 设置用户权限信息到本地存储
export function setPermissions(permissions) {
  localStorage.setItem('permissions', permissions);
}
// 从本地存储获取用户权限信息
export function getPermissions() {
  const permissions = localStorage.getItem('permissions');
  return permissions;
}
export function setLoginForm(form) {
  localStorage.setItem('aps', window.btoa(JSON.stringify(form)))
}
export function getLoginForm() {
  let form = JSON.parse(
    window.atob(localStorage.getItem('aps') || 'e30=')
  )
  return form
}

// 设置带有过期时间的 cookie
function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

// 获取指定名称的 cookie 值
function getCookie(name) {
  const cookieName = name + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) == ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(cookieName) == 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return null;
}

// 删除指定名称的 cookie
function deleteCookie(name) {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;';
}
